var render = function render(){var _vm=this,_c=_vm._self._c;return _c('summary-count',{attrs:{"title":"Activities Due","is-loading":_vm.isLoading,"count":_vm.activities,"change-count":null,"tooltip":_vm.tooltipText}})
}
var staticRenderFns = []

export { render, staticRenderFns }